export default __webpack_public_path__ + "static/media/bulb_off.29e37d69.png";